import { inject, Injectable } from '@angular/core';
import { env } from '../../../app.constant';
import { NumberService } from './number.service';

@Injectable({
  providedIn: 'root'
})
export class BudgetReportsSABAUDBUtilService {

  public numService = inject(NumberService);

  thousandSeparator(n: string | number) {
    let val = this.numService.thousandSeparator(n);
    return (typeof val === "string") ? val : "";
  }

  formatNegativeNumber(strNumber: any) {
    let n = parseFloat(strNumber.replaceAll(",", ""));
    if (!n) {
      return "";
    }
    return (n < 0) ? `(${strNumber.replace("-", "")})` : strNumber;
  }

  ifHeader(code: string = "") {
    return (code.substring(code.length - 4) == "0000" || code == "00") ? true : false;
  }

  getRomanNumber(code: string = "00") {
    return (code.length === 2) ? env.roman_numbers[code] : env.roman_numbers[code.substring(code.length - 6, code.length - 4)];
  }

  indention(item: any): Array<any> {
    let indention = [];

    if (item.hasOwnProperty('indention')) {
      for (let i = 0; i < item.indention; i++) { indention.push(i); }
    }
    return indention;
  }

  isBalance(item: any) {
    let a = Number(item.ors_total) - Number(item.dis_total);
    let b = Number(item.due_demandable) + Number(item.not_yet_due);
    return (a.toFixed(2) == b.toFixed(2));
  }

}
